// extracted by mini-css-extract-plugin
export default {"pricingWrapper":"TerminalPricing_pricingWrapper__tDxES","pricingTitle":"TerminalPricing_pricingTitle__yl5iQ"};